<template>
    <v-list-item>
        <template>
            <v-form v-model="valid" lazy-validation>
                <v-row>
                    <v-col md="12">                    
                        <v-text-field
                            label="Title"
                            v-model="template.title"
                            :rules="rules"
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    <v-col md="12">
                        <v-textarea 
                            rows="3"
                            v-model="template.text"
                            label="Message Text"
                        ></v-textarea>
                    </v-col>
                    <v-col md="12" class="d-flex justify-end">
                        <v-btn color="blue darken-1" text @click="remove">
                            Remove
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="update" :disabled="!this.valid">
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </template>
    </v-list-item>
</template>

<script>

import { mapActions, mapMutations } from "vuex";

export default {
    name: "TextMessageForm",
    props: {
        template: Object,
    },
    data() {
        return {
            valid: true,
            rules: [
                value => !!value || 'Required.',
            ],
        };
    },
    methods: {
        ...mapMutations({
            DELETE_SMS: "templates/DELETE_SMS",
        }),
        ...mapActions({
            showHandlerSnackbar: "snackbar/showHandlerSnackbar",
        }),
        update() {
            this.$axios.post('/templates/sms/update', {
                id: this.template.id,
                title: this.template.title,
                text: this.template.text,
            }).then(res => {
                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });
            }).catch(e => {
                console.log('error', e);
            });
        },
        remove() {
            this.$axios.post('/templates/sms/remove', {
                id: this.template.id,
            }).then(res => {
                this.DELETE_SMS(this.template.id);

                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });
            }).catch(e => {
                console.log('error', e);
            });
        }
    },
};

</script>